export class Trainer {
  Name: string;
}
